import React from 'react';

export default function WhyChooseInjuryCompensation() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background overlay with car accident theme */}
      <div className="absolute inset-0 bg-black opacity-40"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-slate-700 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-slate-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse delay-700"></div>
      
      {/* Main content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-5xl mx-auto text-center">
          {/* SEO-optimized header */}
          <header className="mb-8 sm:mb-12">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 leading-tight">
              Why Do People{' '}
              <span className="text-red-500 relative inline-block">
                Choose
                <span className="absolute bottom-0 left-0 w-full h-1 bg-red-500"></span>
              </span>
              <br className="hidden sm:block" />
              <span className="block mt-2">InjuryCompensation.com?</span>
            </h1>
          </header>

          {/* Main content sections */}
          <article className="space-y-6 sm:space-y-8">
            <section className="max-w-4xl mx-auto">
              <p className="text-base sm:text-lg lg:text-xl text-gray-200 leading-relaxed mb-6 sm:mb-8">
                Recovering from a car accident is hard enough without worrying about legal fees. That's why InjuryCompensation.com connects you with skilled, independent auto accident lawyers who understand your situation and fight for your rights. You only pay if they win your case.
              </p>
            </section>

            <section className="max-w-4xl mx-auto">
              <p className="text-base sm:text-lg lg:text-xl text-gray-200 leading-relaxed mb-10 sm:mb-12">
                Whether you were injured in a rollover, rear-end crash, Uber accident, or a government vehicle collision, the attorneys you speak with know how to build your case and fight for the full, fair compensation you deserve.
              </p>
            </section>

            {/* CTA Button */}
            <div className="flex justify-center pt-4">
              <button
                className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold px-8 sm:px-12 py-4 sm:py-5 rounded-full shadow-2xl hover:shadow-red-900/50 transition-all duration-300 transform hover:scale-105 text-base sm:text-lg lg:text-xl border-2 border-red-500"
                aria-label="Begin your path to compensation"
                onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
              >
                Begin Your Path to Compensation
              </button>
            </div>
          </article>
        </div>
      </div>

      {/* SEO-optimized structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Why Choose InjuryCompensation.com",
          "description": "Connect with skilled, independent auto accident lawyers who fight for your rights. You only pay if they win your case.",
          "mainEntity": {
            "@type": "Service",
            "serviceType": "Legal Services",
            "provider": {
              "@type": "Organization",
              "name": "InjuryCompensation.com",
              "description": "Connecting car accident victims with experienced attorneys"
            },
            "areaServed": "United States",
            "audience": {
              "@type": "Audience",
              "audienceType": "Car accident victims"
            }
          },
          "about": {
            "@type": "Thing",
            "name": "Auto Accident Legal Representation",
            "description": "Contingency-based legal services for car accident victims including rollover, rear-end crashes, Uber accidents, and government vehicle collisions"
          }
        })}
      </script>
    </div>
  );
}